export default {
  mainPage: {
    p1: {
      h: '致力科技，引领未来',
      p1: '低碳气体，节能减排，',
      p2: '清洁能源，持续发展。',
      p3: '',
    },
    p2: {
      p1: 'Dimer Technologies 拥有业界领先的气体处理，电力转换制气，碳捕集和利用和清洁能源开发的技术和能力；',
      p2: 'DIMER是起源于澳大利亚国家温室气体研究中心和联邦科学工业研究院（CSIRO）的高科技创新型企业。',
      p3: '',
      p4: '',
    },
    p3: {
      p1: '发现 ', // 此处的DIMER文字固定显示，不需要体现在文本内容中
    },
  },
  mainMenu: {
    homePage: '主页',
    about: '关于DIMER',
    t$e: '技术与工程',
    p$s: '项目与服务',
    contact: '联系我们',
  },
  about: {
    aboutDIMER: '关于我们',
    DIMER_BOARD: '董事会和管理层',
    m$c: '专家顾问委员会',
    a$r: '荣誉与认可',
    latestNews: '最新新闻',
    latestProj: '最新项目',
  },
  t$e: {
    gasProcessTech: '气体处理的技术和工程',
    ptgTech: '电力转换制气的技术和工程',
    cleanEnergyDev: '清洁能源技术',
  },
  p$s: {
    h2ch4Rec$co2Capt: '氢气/甲烷回收和二氧化碳捕获',
    renewablePower: '（可再生）能源转换制氢气',
    co2Sep$Capt: '二氧化碳分离捕获和再利用',
    co2Capt$reuse: '基于氢能/储能的微网系统',
    wasteWaterTreat: '工厂/园区的排放气管理',
  },
  toolBar: {
    searchPlaceholder: '搜索...',
  },
  discoveryPage: {
    title: 'DIMER 的技术和工程能力',
    p1: {
      p1: '气体和新能源等技术和项目的',
      p2: '研发、设计、建造、实施和管理',
    },
    p2: {
      p1: 'DIMER 核心技术和工程能力范围是生产和处理低碳能源气体，',
      p2: '工业排放气或温室气体，碳捕集&转化利用，',
      p3: '电力转换制气及清洁能源开发。',
    },
  },
  discoveryPage2: {
    title: 'DIMER 的愿景和目标',
    p1: {
      p1: '我们爱护空气、保护蓝天...',
      p2: '',
    },
    p2: {
      p1: 'DIMER 追求的宗旨是"低碳，能源，绿色，环保"；',
      p2: '',
      p3: 'DIMER 致力为未来社会寻找更高效的清洁能源；',
      p4: '',
      p5: 'DIMER 为大自然的可持续发展提供节能减排的解决方案。',
      p6: '',
      p7: '',
    },
  },
  discoveryPage3: {
    title: 'DIMER 的应用领域',
    p1: {
      p1: '工业气体，工业尾气，',
      p2: '温室气体，新能源和微网',
    },
    p2: {
      p1: 'DIMER技术重点应用领域是生产低碳能源气体 （如氢气，天然气）；石油化工气体处理； 煤加工和煤化工气体处理； 二氧化碳捕集和利用；甲烷、可燃有机物 （VOCs）排放控制与处置利用；生物与工程固碳技术开发；电厂尾气处理 （CO2捕集与存储）；重工业气体净化与分离；新能源制氢气；电力转换制气。',
      p2: '',
      p3: '',
    },
  },
  contact: {
    title: '联系我们',
    company: '戴莫尔科技公司',
    address: '柯林斯街101号27层',
    city: '墨尔本 3000，澳大利亚',
    phone: 'T: +61 3 9653 6499',
    email: 'E: info_at_dimer.com.au',
  },
  copyright: {
    copyright: '© Dimer Technologies 版权所有，2020。 ACN 155 533 225',
    law: '法律公告：',
    lawLink: '专利和知识产权',
  },
  aboutPage: {
    p1: {
      title: '关于 DIMER',
      p1: 'DIMER 拥有世界领先',
      p2: '多项自主知识产权气体技术。',
      p2_1: '',
      p3: '集中在温室气体（比如CO2，CH4和VOCs）的分离，捕集和回收，氢气回收与提纯，',
      p4: '天然气净化回收，电力转换制气，氧气制造以及富氧燃烧等方面。',
    },
    p2: {
      p1: 'DIMER公司拥有世界领先多项自主知识产权气体技术，集中在温室气体（比如 CO2，CH4和VOCs）的分离、捕集和回收，氢气回收与提纯，天然气净化回收，电力转换制气，氧气制造以及富氧燃烧等方面。DIMER技术和研发起源于澳大利亚温室气体研究中心 （CO2 CRC）、联邦科学与工业研究院 （CSIRO）、美国空气化工（Air Products & Chemical）、澳大利亚墨尔本大学、澳大利亚莫纳什（Monash）大学，和它们以及美国Norton公司等有持续多方位合作机制。',
      p2: '完备的研发体系与世界领先的研发仪器设备',
      p3: 'DIMER依托澳大利亚国家温室气体研发中心、联邦科学与工业研究院、墨尔本大学和蒙纳什大学建立了完备的针对气体分离提纯的研发体系，拥有世界领先的研发仪器设备。DIMER在材料制备、测定、工艺中试、工业化实施和商业化运行，积累了丰富的经验，能够及时根据市场需要和科技进步开发出技术可靠、经济效益可观的新材料和新工艺。',
      p4: 'DIMER的气体技术已经获得澳大利亚、中国、美国、欧洲等多国国际专利，DIMER 具有这些专利的独家所有权或使用权。',
      p5: '国际专利：No.PCT/AU08/01831 （覆盖中国、美国、日本、印度、欧洲）。',
      p6: '英国专利：No.20110005389。',
      p7: '澳大利亚专利：No.2008336265，No.2013201122/No.2016201267。',
      p8: '中国专利：No.201611219796.5，No.201621438243.4。',
      news: {
        state: '进行中的项目',
        news1: '石化炼油厂制氢尾气的分离回收',
        news2: '可再生能源转换制氢气',
        news3: 'CO2捕捉和液化',
        news4: 'CH4甲烷分离、提纯和液化',
      },
    },
    p3: {
      title: '董事会与管理层',
      p1: `DIMER公司创立者和核心成员是资深教授和高级科学家。他们拥有美国麻省理工学院，澳大利亚科学院，
      澳大利亚墨尔本大学和蒙纳什大学，美国空气化学公司，中国北京大学、清华大学和天津大学的教育和工作资历。
      DIMER同时得到美国Norton公司的技术支持，具备强大的科技资源和创造力。`,
      userInfo: {
        DrLMS: {
          name: '刘明升 博士',
          description: '联合创始人/常务执行董事/总裁',
          content: `刘明昇博士是DIMER创始人之一，并出任常务执行董事。
          刘明昇博士曾任澳大利亚联邦科学与技术研究院高级科学家，项目组负责人，荣誉院士. 他是材料分子设计，先进高分子/纳米材料开发，气体吸附分离技术和工程的专家，也是清洁能源EPC （国际工程总承包项目） 项目开发、融资和管理专家。刘博士曾获得澳大利亚墨尔本大学材料物理博士。`,
        },
        PfPaul: {
          name: 'Paul Webley 教授',
          description: '联合创始人/执行董事',
          content: 'Paul Webley教授是DIMER创始人之一，并出任执行董事。 Paul Webley教授现任Woodside-Monash能源中心主任、莫纳什大学氢能中心主任和化工系教授、澳大利亚国家温室气体中心首席专家。Webley教授是气体分离技术、低碳能源、新材料以及能源结构优化专家。也曾任墨尔本大学化工学院院长、美国空分公司高级经理。Webley教授曾获得美国麻省理工学院博士。',
        },
        MrTJing: {
          name: 'Thomas Jing 先生',
          description: '执行董事',
          content: 'Thomas先生出任戴莫尔执行董事、美启能源（中国）联席总裁。美启一直致力于低碳清洁能源的发展，在低碳气体、清洁能源利用、IGCC发电和储能储热等方面处于行业领先位置。美启集团是戴莫尔科技在中国区的合作伙伴。',
        },
        DrZJ: {
          name: 'Tony Zhang 博士',
          description: '联合创始人',
          content: `Zhang博士是DIMER创始人之一。
          Dr Zhang曾任澳大利亚国家温室气体中心项目经理和研究院。Zhang博士取得澳大利亚蒙纳什大学博士，是温室气体分离、吸附材料开发、清洁煤和节能减排技术开发专家。`,
        },
        DrPenny: {
          name: 'Penny Xiao 博士',
          description: '首席技术官',
          content: 'Penny是戴莫尔科技首席技术官、兼任墨尔本大学清洁能源研究室高级研究员。Xiao博士是气体分离和回收，吸附材料开发，清洁煤气，节能减排技术开发专家；Xiao博士是澳大利亚墨尔本大学博士、蒙纳什大学 （Monash） 博士后。',
        },
        MrYCQ: {
          name: '于长青 先生',
          description: '中国项目运行总监',
          content: '于长青先生是高级工程师，拥有25+年的石油化工工作经验，专长于气体分离处理、气体液化和工程项目建设和运行。目前他负责DIMER在中石化炼油厂的氢气系统的运行。',
        },
        AliciaLi: {
          name: 'Ms Alicia Li （FA，MIntlB）',
          description: '资本管理顾问',
          content: 'Alicia是资深认证的理财顾问，她有20+年的金融机构任职经验，专长于公司和个人财务管理。 她目前负责公司的财务规划和资本风险管理。',
        },
        DrTao: {
          name: '陶乐夫 博士',
          description: '技术经理',
          content: '陶博士是化工工艺，气体分离技术和吸附材料开发专家。他加入DIMER前曾经在BASF-中国工作多年，曾取得了清华大学本科硕士、澳大利亚墨尔本大学博士。',
        },
      },
    },
    p4: {
      title: '专家顾问委员会',
      userInfo: {
        DrKL: {
          name: 'Dr Kevin Li',
          company: 'UniMelb',
        },
        ProfPW: {
          name: 'Professor Paul Webley',
          company: 'UniMelb',
        },
        DrRT: {
          name: 'Dr Richard Todd',
          company: 'Norton',
        },
        MrMjL: {
          name: 'Mr Mengjiang Liu',
          company: 'Skywell',
        },
        DrDX: {
          name: 'Dr Ding Xue',
          company: 'Sinopec',
        },
        MrJsL: {
          name: 'Mr Junshan Liu',
          company: 'CNOOC',
        },
      },
    },
    p5: {
      title1: 'DIMER',
      title2: ' 荣誉与认可',
      content: '2017 AustCham Westpac Australia-China Business Awards（ACBAs），DIMER 被提名为"企业创新与数字经济-商业卓越奖"以及"中小型企业-商业卓越奖"。并最终摘得"企业创新与数字经济-商业卓越奖"。',
    },
  },
  techPage: {
    p1: {
      title: '技术与工程',
      p1: 'DIMER 专注专长于',
      p2: '气体处理、低碳能源气体开发，',
      p3: '温室气体的捕集和利用以及清洁能源开发。',
      p4: '',
      p5: '核心技术和工程服务是生产、分离和处理低碳工业气体，工业排放气',
      p6: '或温室气体捕集&转化及清洁能源制气。',
    },
    p2: {
      title: '核心技术和工程能力',
      p1: 'DIMER核心技术和工程能力是变压吸附技术处理工业排放气或温室气体，以及电力转换制气。与现有气体技术的比较，DIMER技术发明更精简高效多床变压吸附系统来回收/处理各种工业生产或排放的气体（如氢气H2、甲烷CH4、二氧化碳CO2，以及VOCs），并浓缩或液化到可利用的浓度水平。',
      p2: 'DIMER气体技术已经在澳大利亚、中国等多国实施，都达到/超出厂家预期，实现了低成本气体处理的生产效益，以及节能减排的环境效益。',
      p3: ' ',
      p4: '',
    },
    p3: {
      title: '气体处理的技术和工程',
      p1: '针对能源、石油化工、天然气、煤化工等行业需要处理大量的工业气体、排放气和温室气体，DIMER开发了：',
      p2: '- 低分压变压吸附VSA分离提纯二氧化碳、甲烷的技术和工艺；',
      p3: '- 低分压变压吸附VSA/PSA耦合回收提纯氢气的技术和工艺；',
      p4: '- 变温变压吸附TSA气体净化和液化的技术和工艺；',
      p5: '- 工业尾气碳捕集和转化 CCS&CCUS。',
      p6: '',
    },
    p4: {
      title: '电力转换制气的技术和工程',
      p1: '电力转换制气是以电能高效率制造氢气、甲烷、氨等气体的技术。特别当利用太阳能或风能等可再生能源或剩余电力时，该技术将为电力和氢能提供可靠的优化协同发展。',
      p2: 'DIMER携手合作伙伴开发了先进的电力转换制气的技术和能力：',
      p3: '- 清洁能源制氢气 （Power-to-H2）；',
      p4: '- 碳捕集转换制造甲醇或甲烷；',
      p5: '- 氢能应用。',
      p6: '',
      p7: '',
    },
    p5: {
      title: '清洁能源的技术和项目',
      p1: '针对气体/氢能在微电网或分布式能源的应用，尤其结合新能源特点，满足工业或农业的电力/蒸汽/热能等需求。',
      p2: 'DIMER联合TeraSolar光热技术、美启和其它微电网技术伙伴着力开发：',
      p3: '- 光热和光电能源；',
      p4: '- 微电网和微能网。',
      p5: '',
    },
    relevant: {
      title: '相关项目',
      project1: '氢气或甲烷回收和二氧化碳捕获',
      project2: '电力转换制气',
      project3: '二氧化碳分离捕获和再利用',
      project4: '基于氢能/储能的微网系统',
      project5: '工厂/园区的排放气综合治理',
      knowMore: '了解更多',
    },
  },
  projectPage: {
    p1: {
      title: '项目与服务',
      p1: 'DIMER 的工程能力和业绩',
      p2: '',
      p3: '多领域项目的可研、设计、施工、',
      p4: '运行，以及EPC融资、管理和咨询。',
      p5: '例如：低碳工业气体，工业排放气体或温室气体，',
      p6: '以及清洁能源制气。',
    },
    p2: {
      p1: 'DIMER核心技术、工程和服务是变压吸附技术处理工业排放气或温室气，以及电力转换制气。',
      p2: '与现有气体技术的比较, DIMER技术采用更精简、高效、多床变压吸附系统来回收各种工业气体和排放废气（如氢气H2、甲烷CH4、二氧化碳CO2、VOCs），并浓缩到可再利用的浓度水平。',
      p3: 'DIMER技术已经在澳大利亚等多国实施。DIMER并承担参与了一系列国际工程总承包（EPC）项目的开发，管理和咨询工作。',
    },
    p3: {
      title: '天津石化制氢尾气氢气/甲烷气回收和CO2捕获技术',
      time: 'SINOPEC, Stage 1: 2015 - 2017; Stage 2: 2018 – present.\n',
      p1: '石化炼油工艺制氢系统一般用变压吸附分离提纯从甲烷中制取的氢气，供给下游工艺使用。该制氢系统的尾气含有大量可燃性气体 （例如该尾气含30%的氢气，49.8%的二氧化碳），DIMER正设计建造更高效益的PSA技术对中国石化天津公司制氢尾气的二氧化碳进行捕捉以及氢气/甲烷气的分离提纯. 此工程不但会减少天津石化温室气体排放，而且创造了新的清洁能源高纯氢气/甲烷气。',
    },
    otherProjects: {
      title: '其他项目',
      t$eImg1: {
        title: '电力转换制氢气',
        time: '2019- 至今',
        p1: '澳大利亚和世界多国一样，新能源发电面临\'放弃光弃风\'和电网不稳定问题。DIMER设计把盈余的能源电力通过水电解制造H2和O2，H2可以进一步注入天然气网络、或用于氢能运输工具或者其它工业用途，甚至氢可以与二氧化碳混合并通过甲烷化反应或其他CH化合反应合成甲醇、乙醇或甲烷等等。H2也可以通过燃料电池转换回到电力网络。',
      },
      t$eImg2: {
        title: '饮料生产线CO2捕集，提纯和再利用',
        time: '2008 - 2010',
        p1: '饮料行业使用并释放大量食品级二氧化碳，造成资源的巨大浪费。基于二氧化碳市场供需状况和生产需求，2008年澳大利亚可口可乐提出由我们设计技术方案回收其某罐装车间尾气，通过与可口可乐的合作，在反复讨论、论证的基础上，DIMER提出了全新的自有知识产权技术方案，在低能耗的前提下最大的程度的回收提纯二氧化碳，同时确保回收气体的食品级高质量要求. 该工艺二氧化碳收率和纯度均超出客户预期，并且本工艺未引入其他任何化学物质，确保了气体符合食品级要求。另外，该工艺设备根据罐装工艺的特点（e.g.卡瓶，经常性短停车等问题），设计了适应性强的数控过程，使二氧化碳收率和纯度满足要求。',
      },
      t$eImg3: {
        title: '澳大利亚墨尔本自来水公司废水处理项目',
        time: '2009',
      },
      t$eImg4: {
        title: '澳大利亚墨尔本自来水公司废水处理项目',
        time: '2008-2010',
      },
    },
    projectList: {
      project1: {
        name: '炼化尾气中氢气/甲烷回收和二氧化碳捕获',
        time: '中石化： 2015-2017 一期；2018-至今 二期',
        content: '石化炼油工艺制氢系统一般用变压吸附分离提纯从甲烷蒸汽重整中制取的氢气，供给下游工艺使用。该制氢系统的尾气含有大量可燃性气体（例如该尾气含30%的氢气，49.8%的二氧化碳）。DIMER正设计建造高效益的VSA/PSA耦合技术对中国石化制氢尾气和气体尾气中的二氧化碳进行捕捉以及氢气/甲烷气的分离提纯。此技术和工程不但会减少中国石化温室气体排放，而且创造了新的清洁能源高纯氢气/甲烷气。',
      },
      project2: {
        name: '可再生能源转换制氢气',
        time: '2019 - 至今',
        content: '澳大利亚和世界多个国家一样，新能源发电面临电网不稳定和‘弃光弃风’问题。DIMER设计把新能源或者其它盈余的电力通过水电解制造H2和O2，H2作为零碳能源介质可以把电能储存起来。H2可以进一步注入天然气网络，或用于氢能运输工具或者其它工业用途，甚至氢可以与二氧化碳混合并通过甲烷化反应或其他CH化合反应合成甲醇、乙醇或甲烷等等。H2也可以通过燃料电池转换回到电力网络。\n' +
          '和合作伙伴一起，DIMER在投资建设微网级、可商业运行的电力制氢系统，实现将高纯氢气（99.999%）在线生产、注入燃气、氢能汽车或氢能发电的商业运行。\n',
      },
      project3: {
        name: '二氧化碳分离捕获和再利用',
        time: '2007 - 2013',
        content: '法国能源公司GDF Suez在澳洲的某燃煤发电厂提出回收二氧化碳以用来中和处理高pH值含碱废水，二氧化碳需求量为20-50吨每天。GDF Suez要求工艺技术可靠性高，自动化程度高，能耗低，运行费用低，人员配置要求低。根据该燃煤电厂烟道尾气的情况和DIMER的技术优势，我们为GDF Suez提供了利用变压吸附分离提纯二氧化碳，并压缩供给下游废水处理的方案。与其他技术方案相比，我们的方案设备模块化、集成化、效率高、能耗低、易于维护，为该公司产生可观的经济和社会效益。',
      },
      project4: {
        name: '基于氢能/储能的微网系统',
        time: '2018 - 至今',
        content: '为满足工业、农业、矿山或社区的电力/蒸汽/热能等需求， DIMER联合TeraSolar光热技术，Aurorean Energy和其它微电网技术伙伴着力开发气体/氢能介质在微电网或分布式能源的应用，尤其结合新能源特点，实施热（蒸汽）、电、气的联产联供，实现智能化能源供给。\n' +
          '\n' +
          '目前为澳洲某电力公司，某天然气公司，某食品加工企业等分别完成可研设计和基础设计，正在推进项目EPC实施。\n',
      },
      project5: {
        name: '工厂/园区的排放气综合治理',
        time: '2019 - 至今',
        content: '工业生产会产生大量的水、气、渣等有害废物。工业排放气的主要集中在少数几个行业，比如石油、化工、电力、钢铁冶金、食品、煤炭、建材和纺织等排放量占总量的80%以上。工业生产中超量排放废气或尾气，会严重地污染环境，破坏生态和自然，对生产、环境和人类生活造成难以恢复的危害。\n' +
          '\n' +
          'DIMER正和中石化炼油厂、化工厂以及地方化工园区紧密协作，探讨利用DIMER的气体处理技术对厂区或园区的工业排放气进行综合治理：系统地有效地回收气体，减少对环境有害气体或温室气体的排放，实现环境效益和经济效益。\n',
      },
    },
    pastProjectList: {
      project1: {
        title: '',
        time: '',
      },
      project2: {
        title: '',
        time: '',
      },
      project3: {
        title: '',
        time: '',
      },
      project4: {
        title: '',
        time: '',
      },
    },
    globalPartner: {
      title: 'DIMER 项目和合作伙伴',
      p1: '我们倾听，我们理解，',
      p2: '我们和您一起创造，领先技术和品质工程 ... ',
      p3: '',
    },
  },
  contactPage: {
    p1: {
      title: '联系我们',
      shanghaiOffice: {
        name: '上海办公室',
        area: '中国上海市浦东新区',
        address: '陆家嘴环路1318号星展银行大厦21层',
        mCode: '200120',
        phone1: 'T: +86 21 6886 9881',
        phone2: 'F: +86 21 6886 9882',
        email: 'E: info_at_dimer.com.au',
      },
      guangzhouOffice: {
        name: '广州办公室',
        area: '中国广州市天河区',
        address: '珠江新城金穗路一号邦华环球广场30层',
        mCode: '510623',
        phone1: 'T: +86 20 8638 8698',
        phone2: 'F: +86 20 8638 8798',
        email: 'E: info_at_dimer.com.au',
      },
      MelbourneOffice: {
        name: '总部办公室',
        area: 'Level 27, 101 Collins Street,',
        address: 'Melbourne 3000',
        mCode: 'Australia',
        phone1: 'T: +61 3 96536499',
        phone2: '',
        email: 'E: info_at_dimer.com.au',
      },
    },
    p2: {
      title: '需要我们为您做些什么？请直接填写下述表格：',
      name: '姓 名',
      email: '邮 箱',
      contact: '联系方式',
      message: '您的留言',
      sendMessage: '发送信息',
    },
    p3: {
      title: '合作伙伴链接',
      content: '我们力求成为客户的战略合作伙伴，我们知道每个公司或企业都是独一无二的。',
    },
  },
};



// WEBPACK FOOTER //
// ./src/lang/zh.js